import { render, staticRenderFns } from "./podcasts.vue?vue&type=template&id=65be5273&scoped=true"
import script from "./podcasts.vue?vue&type=script&lang=js"
export * from "./podcasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be5273",
  null
  
)

export default component.exports